import styled from '@emotion/styled'

export const PaymentsWrapper = styled.div`
  min-width: 0;
`
